import { Dispatch } from 'react';
import { AxiosError } from 'axios';
// import { notification } from 'antd';
import { IAction } from './i-action';
import { UserActionType } from '../user/user.enum';

// make more functional
export const handleError = (
  dispatch: Dispatch<IAction>,
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
) => (error: AxiosError) => {
  if (error?.response?.status === 401) {
    // eslint-disable-next-line
    console.warn(error);
    dispatch({
      type: UserActionType.UNAUTHORIZED_ERROR,
      payload: error,
    });
  } else {
    // eslint-disable-next-line
    console.error(error);
    // TODO: no errors will be displayed until we fix the token refresh and refine the
    // error display UX
    // notification.error({
    //   placement: 'topRight',
    //   bottom: 50,
    //   duration: 3,
    //   message: `Error. Status: ${error?.response?.status} (${error?.response?.statusText})`,
    //   // description: error?.response?.data?.status ? '' : error?.response?.data,
    //   className: 'notification-type-info',
    // });
  }
};

export default handleError;
